import Modal from "react-modal";
import { useTranslation } from "react-i18next";

export const PosUploadModal = ({
    visible,
    onClose,
    isConnectedPOS,
    onImport,
    POSConection,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            closeTimeoutMS={200}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full sm:max-w-2xl sm:mx-auto"
            style={{
                overlay: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(107, 114, 128, 0.75)",
                },
                content: { overflow: "hidden" },
            }}
        >
            <>
                <div className="px-12 pt-10 pb-2.5">
                    <div className="font-bold text-xl mb-2.5">
                        {t("Import from POS")}
                    </div>

                    <div className="bg-white overflow-y-auto">
                        <div className="text-xs font-medium">
                            {isConnectedPOS
                                ? t(
                                      "You have already succesffuly connected your POS system to Cheqit and can now automatically import your entire menu onto Cheqit by clicking import below"
                                  )
                                : t(
                                      "It looks like your POS system has not been connected to Cheqit. Please click continue to access your store POS settings page where you can find and connect to your POS system. Once connected you will then be able to initiate the import."
                                  )}
                        </div>
                    </div>
                </div>

                <div className="pt-11 pb-5 px-12 text-right">
                    <button
                        type="button"
                        className="inline-flex justify-center mr-2 py-1.5 px-6 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-300 hover:bg-gray-400 activ:bg-gray-500 focus:outline-none"
                        onClick={onClose}
                    >
                        {t("Cancel")}
                    </button>

                    {isConnectedPOS ? (
                        <button
                            onClick={onImport}
                            type="submit"
                            className="inline-flex justify-center py-1.5 px-6 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                        >
                            {t("Import")}
                        </button>
                    ) : (
                        <button
                            onClick={POSConection}
                            type="submit"
                            className="inline-flex justify-center py-1.5 px-6 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                        >
                            {t("Continue")}
                        </button>
                    )}
                </div>
            </>
        </Modal>
    );
};
